import { h, Fragment } from "preact"

export const CollectionList = ({collections, query}) => {
  return (
    <Fragment>
      <div class="search-drop__title h6">{ theme.search_collections }</div>
      <ul class="search-drop__list">
        { collections.map(collection => (
          
          <li key={ collection.id }>
            <a href={ `/collections/${ collection.handle }` } dangerouslySetInnerHTML={ {__html: collection.title.replace(new RegExp(query, "gi"), (match) => `<b>${match}</b>`)} }></a>
          </li>
        )) }
      </ul>
    </Fragment>
  )
}
